export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_11-EN-b36e1ecde2ba4dd2aabc8ffbe93c36b6.webp";